import StringFormat, { formatMessage } from "./string-format";
import { PANDA_INSTANCES, PANDA_I18N_PACK } from "../../const";
import { debugInfo, debugError } from "../index";
import { i18nMapping } from "../../services";
export function initial(strings, options) {
  var name = options.name,
    lang = options.lang;
  window[PANDA_INSTANCES] = window[PANDA_INSTANCES] || {};
  window[PANDA_INSTANCES][name] = new StringFormat(strings, lang);
}
export function format(des, variable, options) {
  var _ref = options || {},
    name = _ref.name,
    nameSpace = _ref.nameSpace,
    lang = _ref.lang,
    type = _ref.type,
    packageName = _ref.packageName;
  var instances = window[PANDA_INSTANCES] || {};
  // 当nameSpace不为空且不等于name时，则去找到ns相关实例
  var instance;
  if (!nameSpace || nameSpace === name || name.includes('.') && instances[name]) {
    instance = instances[name];
  } else {
    // 在查找的ns的name时，为了保证找到的准确性，在找到lang语种的时候去会得到置入该语种的nameSpace的name
    // 由于存在老的实例 使用的key是strings 所以只判断新的locale的key
    // 由于可能存在多版本，为了确保实例中的版本能确定找到新版本，顾加入StringFormat的v属性的判断
    var findName = nameSpace && packageName ? Object.keys(instances).find(function (key) {
      return key.startsWith(nameSpace + '.' + packageName);
    }) : Object.keys(instances).find(function (key) {
      var _instances$key$locale, _instances$key;
      return key.startsWith(nameSpace) && ((_instances$key$locale = instances[key].locale) === null || _instances$key$locale === void 0 ? void 0 : _instances$key$locale[lang]) && !!((_instances$key = instances[key]) !== null && _instances$key !== void 0 && _instances$key.format2);
    }) || Object.keys(instances).find(function (key) {
      var _instances$key2;
      return key.startsWith(nameSpace) && !!((_instances$key2 = instances[key]) !== null && _instances$key2 !== void 0 && _instances$key2.format2);
    });
    instance = instances[findName];
  }
  if (!instance) {
    debugInfo("No translation found, pls make sure u passed the translation b4 1st $i18n.get func.");
    debugError({
      instanceName: name,
      translationId: des.id
    });
    return formatMessage(des.defaultMessage || des.id || '', variable);
  }
  var _instance$format = instance.format2(des, variable, options),
    message = _instance$format.message,
    usedLang = _instance$format.usedLang,
    isMatched = _instance$format.isMatched;
  if (window.__PANDA.isI18nPdkv || window.__PANDA.debug) {
    var _window$PANDA_I18N_PA, _window$PANDA_I18N_PA2, _window$PANDA_I18N_PA3, _window$PANDA_I18N_PA4;
    // 组件的名字来自于 nameSpace 或者 name的前置 如 MyComponent.1dfk23fg
    var componentName = nameSpace || (name.includes('.') ? name.split['.'][0] : '');
    // 如果设置了组件名或者包名，则认为不来自于CDN翻译
    var packId = !componentName && !packageName ? (_window$PANDA_I18N_PA = window[PANDA_I18N_PACK]) === null || _window$PANDA_I18N_PA === void 0 ? void 0 : (_window$PANDA_I18N_PA2 = _window$PANDA_I18N_PA[usedLang.replace('-', '_')]) === null || _window$PANDA_I18N_PA2 === void 0 ? void 0 : (_window$PANDA_I18N_PA3 = _window$PANDA_I18N_PA2.copyList) === null || _window$PANDA_I18N_PA3 === void 0 ? void 0 : (_window$PANDA_I18N_PA4 = _window$PANDA_I18N_PA3[des.id]) === null || _window$PANDA_I18N_PA4 === void 0 ? void 0 : _window$PANDA_I18N_PA4.packId : '';
    // 反向获取语言包id
    return i18nMapping.encrypt(message, {
      copyKey: des.id,
      type: type,
      componentName: componentName,
      packageName: packageName,
      packId: packId,
      isMatched: isMatched
    });
  }
  return message;
}
export function setLocaleToInstance(locale, name) {
  var instances = window[PANDA_INSTANCES] || {};
  var instance = instances[name];
  if (!instance) {
    debugInfo('No translation found');
    debugError({
      instanceName: name
    });
    return;
  }
  instance.setLocale(locale);
}